var map = {
	"./absa.png": "7177",
	"./card-logos.png": "cee1",
	"./card-logos_legacy.png": "85f5",
	"./eft-secure.png": "b874",
	"./fnb.png": "847d",
	"./ipay.png": "78d0",
	"./nedbank.png": "fbe2",
	"./pnp.png": "a57e",
	"./pnp_radio.png": "75ee",
	"./standard-bank.png": "20a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5427";